module.exports = __webpack_public_path__ + "static/media/banner-2-Mobile-1.dc1acaa7.jpg";